/**
 * If you need to add a new tracker check the bundles:
 * - SegmentBundle For NHS
 * - PartnerTrackersBundle for PL and CNA
 */
(function index(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Analytics = global.NewHomeSource.Analytics || {};

  if (!global.NewHomeSource.Analytics.impressionTracker ||
    !global.NewHomeSource.Analytics.identityTracker ||
    !global.NewHomeSource.Analytics.eventTracker ||
    !global.NewHomeSource.Modules.IdleQueue ||
    !global.NewHomeSource.Modules.IdleValue ||
    !global.NewHomeSource.Modules.tagManager ||
    !global.NewHomeSource.Modules.cookieHandler ||
    !global.NewHomeSource.UserCredentials
  ) {
    return;
  }

  const nhsTrackingId = 'UA-40843711-4';

  /**
   * @private getCentralStandardTime: get Central Standard Time (Austin time).
   *
   */
  function getCentralStandardTime() {
    // Get current time
    const date = new Date();

    // The difference, in minutes, between the date as evaluated in the UTC time zone and
    // as evaluated in the local time zone. The actual local time algorithm is implementation-defined,
    // and the return value is allowed to be zero in runtimes without appropriate data.
    const browsertTimeZone = date.getTimezoneOffset();

    // convert browsertTimeZone to milliseconds
    // get UTC time in milliseconds
    const utc = date.getTime() + (browsertTimeZone * 60000);

    //  Get the number of milliseconds of central standard time.
    // 3600000 is the conversion of hours to milliseconds
    // -5 is the GMT-5 time zone of austin. We just need to multply the value.
    // 3600000 * -5 = -18000000 milliseconds
    const centralStandardTimeZone = -18000000;

    // Calculate the new date with the central standard timezone.
    const now = new Date(utc + centralStandardTimeZone);

    return `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}` +
    `T${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}.${now.getMilliseconds()}-05:00`;
  }

  function getResultCount() {
    return window.NewHomeSource.Modules.tagManager.getFromDataLayer('matchingResults');
  }

  function getFiltersApplied() {
    const filtersApplied = global.NewHomeSource.Modules.tagManager.getFromDataLayer('filtersApplied');
    if (!filtersApplied) {
      return undefined;
    }

    const filters = JSON.parse(filtersApplied);
    const propNames = Object.getOwnPropertyNames(filters);
    for (let i = 0; i < propNames.length; i += 1) {
      const propName = propNames[i];
      if (filters[propName] === null || filters[propName] === false ||
        filters[propName] === 0 || filters[propName] === '') {
        delete filters[propName];
      }
    }
    return filters;
  }

  function getPageType() {
    return window.NewHomeSource.Modules.tagManager.getFromDataLayer('pageType');
  }

  function getSegmentAnonymousId() {
    return window.NewHomeSource.Modules.tagManager.getFromDataLayer('segmentAnonymousID');
  }

  function getBrandName() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('brandName');
  }

  function getBrandId() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('brandId');
  }

  function getCurrentPageNumber() {
    return window.NewHomeSource.Modules.tagManager.getFromDataLayer('currentPageNumber');
  }

  function getresponseVersion() {
    return window.NewHomeSource.Modules.tagManager.getFromDataLayer('adaptiveTemplate');
  }

  function getPartnerId() {
    return window.NewHomeSource.Modules.tagManager.getFromDataLayer('partnerId');
  }

  function getPartnerName() {
    return window.NewHomeSource.Modules.tagManager.getFromDataLayer('partnerName');
  }

  function getPriceReduction() {
    return window.NewHomeSource.Modules.tagManager.getFromDataLayer('priceReduction');
  }

  function getBrandPartnerName() {
    return window.NewHomeSource.Modules.tagManager.getFromDataLayer('brandPartnerName');
  }

  function getBrandPartnerNamePartnerName() {
    return `${getBrandPartnerName()}-${getPartnerName()}`;
  }

  function getCommunityId() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('communityId');
  }

  function getCommunityType() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('communityType');
  }

  function getProjectType() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('projectType');
  }

  /**
   * @private
   * getMarketId: get the market id of the current page.
   * The difference between @see {@link getUserMarketId} is that getMarketId gets the
   * market id depending on the page search by the user, and @see {@link getUserMarketId}
   * gets the market id accoding the real location (IP address) of the user.
   *
   * @returns market id from dataLayer.
   */
  function getMarketId() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('marketId') || '';
  }

  function getMarketName() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('marketName') || '';
  }

  function getCodeBuildVersion() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('buildCodeVersion');
  }

  function getAbTestsOnThePage() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('AbTestOnThisPage');
  }

  function getBuilderId() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('builderId');
  }

  function getBuilderDivision() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('builderDivision');
  }

  function getBuilderName() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('builderCorp');
  }

  function getCommunityName() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('communityName');
  }

  function getOffMarket() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('OffMarket');
  }

  function getPrimaryImageUrl() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('PrimaryImage');
  }

  function getLowPrice() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('PriceLow');
  }

  /**
   * @private hasIfp: get a value indicating if it has interactive floor plans images.
   *
   * @returns {boolean} indicating it has interactive floor plans images.
   */
  function hasIfp() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('hasIfp');
  }

  /**
   * @private hasIsp: get a value indicating if it has interactive site plans images.
   *
   * @returns {boolean} indicating it has interactive site plans images.
   */
  function hasIsp() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('hasIsp');
  }

  function getHomePrice() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('HomePrice');
  }

  function getHighPrice() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('PriceHigh');
  }

  /**
   * @private isLimitedAvailability: get a value indicating if it is limited availability.
   *
   * @returns {boolean} indicating it is limited availability.
   */
  function isLimitedAvailability() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('isLimitedAvailability');
  }

  /**
   * @private isPriced: get a value indicating if it has priced.
   *
   * @returns {boolean} indicating has priced.
   */
  function isPriced() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('isPriced');
  }

  function getCity() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('city');
  }

  function getCounty() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('County');
  }

  function getIUid() {
    return window.NewHomeSource.Modules.tagManager.getFromDataLayer('i_uid');
  }

  function getState() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('State');
  }

  function getZip() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('ZipCode');
  }

  function getPlanId() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('planId');
  }

  function getPlanName() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('planName');
  }

  function getSpecId() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('specId');
  }

  function getHomeType() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('homeStatus');
  }

  function getWasMatchedAsSpotlightResult() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('wasMatchedAsSpotlightResult');
  }

  function getResultPosition() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('resultPosition');
  }

  /**
   * @private getLocation: get the the city, state.
   *
   * @returns A string that contains {City} - {State}.
   */
  function getLocation() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('location') || '';
  }

  function getUserId() {
    const userId = global.NewHomeSource.Modules.cookieHandler.readCookie('Profile', true);

    if (userId) {
      return userId.replace('{', '').replace('}', '');
    }

    return userId;
  }

  function getGoogleAnalyticsClientId() {
    let googleAnalyticsId;

    if (global.ga && global.ga.getAll) {
      const trackers = global.ga.getAll().filter((element) => element.get('trackingId') === nhsTrackingId);
      googleAnalyticsId = trackers[0].get('clientId');
    }

    return googleAnalyticsId;
  }

  function getGoogleAnalyticsUserId() {
    let googleAnalyticsUserId;

    if (global.ga && global.ga.getAll) {
      const trackers = global.ga.getAll().filter((element) => element.get('trackingId') === nhsTrackingId);
      googleAnalyticsUserId = trackers[0].get('userId');
    }

    return googleAnalyticsUserId;
  }

  /**
   * @private getMarketSession: get the market format to database team in Google Analytics.
   *
   * @returns A string that contains {Market Name} - {Market Id}.
   */
  function getMarketSession() {
    const marketId = getMarketId();
    const marketName = getMarketName();
    if (marketId && marketName) {
      return `${marketName} - ${marketId}`;
    }
    return '';
  }

  function getVisitedMpcIds() {
    return global.NewHomeSource.WebStorageHandler.getSessionStorageItem('visitedMpcIds');
  }

  function startTracking() {
    global.NewHomeSource.Analytics.eventTracker.init();
    global.NewHomeSource.Analytics.identityTracker.init();
    global.NewHomeSource.Analytics.impressionTracker.init();
    global.NewHomeSource.Analytics.onDemandTracker.init();
  }

  /**
   * @private
   * getAmenities: get the value the amenities of dataLayer.
   *
   * @returns amenities value from dataLayer.
   */
  function getAmenities() {
    const amenities = global.NewHomeSource.Modules.tagManager.getFromDataLayer('amenities');
    if (amenities instanceof Array) {
      return amenities.join(', ');
    }

    return amenities || '';
  }

  /**
   * @private
   * getLanguage: get the value the language of document language.
   *
   * @returns nhs language value from docuemnt.
   */
  function getLanguage() {
    return document.documentElement.lang;
  }

  /**
   * @private
   * getReferCode: get the refer code from URL.
   *
   * @returns refer parameter in the URL.
   */
  function getReferCode() {
    const params = new URLSearchParams(window.location.search);
    return params.get('refer');
  }

  /**
   * @private
   * getTrustBuilderReviews: get trust builder reviews value.
   *
   * @returns trust builder reviews value from dataLayer.
   */
  function getTrustBuilderReviews() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('trustBuilderReviews');
  }

  /**
   * @private
   * getUserCity: get city value from IP.
   *
   * @returns city value from dataLayer.
   */
  function getUserCity() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('userCity');
  }

  /**
   * @private
   * getUserState: get state value from IP.
   *
   * @returns state value from dataLayer.
   */
  function getUserState() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('userState');
  }

  /**
   * @private
   * getUserCountry: get country value from IP.
   *
   * @returns country value from dataLayer.
   */
  function getUserCountry() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('userCountry');
  }

  /**
   * @private
   * getUserMarketId: get market id from IP.
   *
   * @returns market id from dataLayer.
   */
  function getUserMarketId() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('userMarketId');
  }

  /**
   * @private
   * getUserStatus: get status of the user.
   *
   * @returns userStatus from dataLayer.
   */
  function getUserStatus() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('userStatus');
  }

  /**
   * @private
   * getUserZipCode: get zip code value from IP.
   *
   * @returns zip code value from dataLayer.
   */
  function getUserZipCode() {
    return global.NewHomeSource.Modules.tagManager.getFromDataLayer('userZipCode');
  }

  /**
   * Retrieves Acxiom tracking properties from the global Acxiom tracking module.
   *
   * @function
   * @returns {Object} The Acxiom tracking properties.
   */
  function getAcxiomTrackingProperties() {
    return global.NewHomeSource.Modules.acxiomDataHandler.getAcxiomTrackingProperties();
  }

  const eventsQueue = new global.NewHomeSource.Modules.IdleQueue();

  const handlers = [];
  const globalValues = {
    abTestsOnThisPage: new global.NewHomeSource.Modules.IdleValue(getAbTestsOnThePage),
    acxiomTrackingProperties: new global.NewHomeSource.Modules.IdleValue(getAcxiomTrackingProperties),
    amenities: new global.NewHomeSource.Modules.IdleValue(getAmenities),
    brand_id: new global.NewHomeSource.Modules.IdleValue(getBrandId),
    brand_name: new global.NewHomeSource.Modules.IdleValue(getBrandName),
    brand_partner_name: new global.NewHomeSource.Modules.IdleValue(getBrandPartnerName),
    brandPartnerNamePartnerName: new global.NewHomeSource.Modules.IdleValue(getBrandPartnerNamePartnerName),
    builder_division: new global.NewHomeSource.Modules.IdleValue(getBuilderDivision),
    builder_id: new global.NewHomeSource.Modules.IdleValue(getBuilderId),
    builder_name: new global.NewHomeSource.Modules.IdleValue(getBuilderName),
    city: new global.NewHomeSource.Modules.IdleValue(getCity),
    codeBuildeVersion: new global.NewHomeSource.Modules.IdleValue(getCodeBuildVersion),
    community_high_price: new global.NewHomeSource.Modules.IdleValue(getHighPrice),
    community_low_price: new global.NewHomeSource.Modules.IdleValue(getLowPrice),
    community_name: new global.NewHomeSource.Modules.IdleValue(getCommunityName),
    communityId: new global.NewHomeSource.Modules.IdleValue(getCommunityId),
    communityType: new global.NewHomeSource.Modules.IdleValue(getCommunityType),
    county: new global.NewHomeSource.Modules.IdleValue(getCounty),
    current_page_number: new global.NewHomeSource.Modules.IdleValue(getCurrentPageNumber),
    filters_applied: getFiltersApplied,
    googleAnalyticsClientId: new global.NewHomeSource.Modules.IdleValue(getGoogleAnalyticsClientId),
    googleAnalyticsUserId: new global.NewHomeSource.Modules.IdleValue(getGoogleAnalyticsUserId),
    hasIfp: new global.NewHomeSource.Modules.IdleValue(hasIfp),
    hasIsp: new global.NewHomeSource.Modules.IdleValue(hasIsp),
    home_price: new global.NewHomeSource.Modules.IdleValue(getHomePrice),
    home_type: new global.NewHomeSource.Modules.IdleValue(getHomeType),
    i_uid: new global.NewHomeSource.Modules.IdleValue(getIUid),
    isLimitedAvailability: new global.NewHomeSource.Modules.IdleValue(isLimitedAvailability),
    isPriced: new global.NewHomeSource.Modules.IdleValue(isPriced),
    language: new global.NewHomeSource.Modules.IdleValue(getLanguage),
    location: new global.NewHomeSource.Modules.IdleValue(getLocation),
    marketId: new global.NewHomeSource.Modules.IdleValue(getMarketId),
    marketName: new global.NewHomeSource.Modules.IdleValue(getMarketName),
    marketSession: new global.NewHomeSource.Modules.IdleValue(getMarketSession),
    offMarket: new global.NewHomeSource.Modules.IdleValue(getOffMarket),
    page_type: getPageType,
    partner_id: new global.NewHomeSource.Modules.IdleValue(getPartnerId),
    partner_name: new global.NewHomeSource.Modules.IdleValue(getPartnerName),
    plan_id: new global.NewHomeSource.Modules.IdleValue(getPlanId),
    plan_name: new global.NewHomeSource.Modules.IdleValue(getPlanName),
    price_reduction: new global.NewHomeSource.Modules.IdleValue(getPriceReduction),
    primary_image_url: new global.NewHomeSource.Modules.IdleValue(getPrimaryImageUrl),
    projectType: new global.NewHomeSource.Modules.IdleValue(getProjectType),
    referCode: new global.NewHomeSource.Modules.IdleValue(getReferCode),
    response_version: new global.NewHomeSource.Modules.IdleValue(getresponseVersion),
    result_count: getResultCount,
    resultPosition: new global.NewHomeSource.Modules.IdleValue(getResultPosition),
    segmentAnonymousId: getSegmentAnonymousId,
    spec_id: new global.NewHomeSource.Modules.IdleValue(getSpecId),
    state: new global.NewHomeSource.Modules.IdleValue(getState),
    time: getCentralStandardTime,
    trustBuilderReviews: new global.NewHomeSource.Modules.IdleValue(getTrustBuilderReviews),
    userAgent: navigator.userAgent,
    userCity: new global.NewHomeSource.Modules.IdleValue(getUserCity),
    userCountry: new global.NewHomeSource.Modules.IdleValue(getUserCountry),
    userId: getUserId,
    userMarketId: new global.NewHomeSource.Modules.IdleValue(getUserMarketId),
    userState: new global.NewHomeSource.Modules.IdleValue(getUserState),
    userStatus: new global.NewHomeSource.Modules.IdleValue(getUserStatus),
    userZipCode: new global.NewHomeSource.Modules.IdleValue(getUserZipCode),
    visitedMpcIds: getVisitedMpcIds,
    wasMatchedAsSpotlightResult: new global.NewHomeSource.Modules.IdleValue(getWasMatchedAsSpotlightResult),
    zip: new global.NewHomeSource.Modules.IdleValue(getZip),
  };

  if (global.NewHomeSource.Analytics.segment) {
    handlers.push(global.NewHomeSource.Analytics.segment);
    global.NewHomeSource.Analytics.segment(globalValues);
  }

  if (global.NewHomeSource.Analytics.SitespeedTracker) {
    handlers.push(global.NewHomeSource.Analytics.SitespeedTracker);
    global.NewHomeSource.Analytics.SitespeedTracker(globalValues);
  }

  global.NewHomeSource.Analytics.GoogleAnalyticsTracker(globalValues);
  handlers.push(global.NewHomeSource.Analytics.GoogleAnalyticsTracker);
  handlers.push(global.NewHomeSource.Analytics.TdvTracker);
  handlers.push(global.NewHomeSource.Analytics.AdWordsTracker);
  handlers.push(global.NewHomeSource.Analytics.BingTracker);
  handlers.push(global.NewHomeSource.Analytics.DotTracker);
  handlers.push(global.NewHomeSource.Analytics.PandoraTracker);
  handlers.push(global.NewHomeSource.Analytics.EnhancedConversionTracker);
  handlers.push(global.NewHomeSource.Analytics.ListHubTracker);
  handlers.push(global.NewHomeSource.Analytics.Ga4Tracker);
  global.NewHomeSource.Analytics.eventTracker(eventsQueue, handlers);
  global.NewHomeSource.Analytics.identityTracker(eventsQueue, handlers);
  global.NewHomeSource.Analytics.impressionTracker(eventsQueue, handlers);
  global.NewHomeSource.Analytics.onDemandTracker(eventsQueue, handlers);
  global.NewHomeSource.Analytics.TdvTracker(globalValues);
  global.NewHomeSource.Analytics.AdWordsTracker(globalValues);
  global.NewHomeSource.Analytics.BingTracker(globalValues);
  global.NewHomeSource.Analytics.DotTracker(globalValues);
  global.NewHomeSource.Analytics.PandoraTracker(globalValues);
  global.NewHomeSource.Analytics.EnhancedConversionTracker(globalValues);
  global.NewHomeSource.Analytics.ListHubTracker(globalValues);
  global.NewHomeSource.Analytics.Ga4Configuration(globalValues);
  global.NewHomeSource.Analytics.Ga4Tracker(globalValues);

  if (global.document.readyState === 'complete') {
    startTracking();
  } else {
    document.addEventListener('DOMContentLoaded', startTracking);
  }
}(window));
